export const toLowerCaseReplaceSpaceWithDash = (item: string): string => {
    return item.trim().toLowerCase().replace(/ /g, '_');
};
